import * as types from './types';

const INITIAL_STATE = {
  fetching: false,
  fetchError: null,
  breakfastItems: [],
  lunchItems: [],
  hasReport: null,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.EXPORT_TOTALS_FETCH_SUCCESS:
      return {
        ...state,
        breakfastItems: payload.BreakfastItems,
        lunchItems: payload.LunchItems,
      };

    case types.EXPORT_TOTALS_FETCHING:
      return {
        ...state,
        fetching: payload,
      };

    case types.EXPORT_TOTALS_FETCH_ERROR:
      return {
        ...state,
        fetchError: payload,
      };

    case types.EXPORT_TOTALS_CLEAR_ERRORS:
      return {
        ...state,
        fetchError: null,
      };

    case types.EXPORT_TOTALS_SET_HAS_REPORT:
      return {
        ...state,
        hasReport: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/exporttotals/state/reducer.js